<template>
  <div id="add_form" class="modal custom-modal fade" role="dialog">
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5
            class="modal-title"
            v-if="formParam.id != '' && formParam.id != null"
          >
            Update Profile
          </h5>
          <h5 class="modal-title" v-else>Add Agent</h5>
          <!-- {{formParam}} -->
          <button
            ref="dismisModal"
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-md-12">
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label>
                      Email:
                      <span class="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="formParam.email"
                      required
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label>
                      First Name:
                      <span class="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="formParam.first_name"
                      required
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label>
                      Last Name:
                    </label>
                    <input
                      type="text"
                      placeholder="Optional"
                      class="form-control"
                      v-model="formParam.last_name"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="submit-section">
            <button
              @click.prevent="saveForm(1)"
              class="btn btn-primary submit-btn"
              type="button"
              :style="'margin-left:10px;'"
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Skeleton } from "vue-loading-skeleton";
import { mapGetters } from "vuex";

import { Datetime } from "vue-datetime";
// You need a specific loader for CSS files
import "vue-datetime/dist/vue-datetime.css";
import {
  formatDate,
  formatDateForMessage,
  getWhatsappNumberFromJid,
  formatSizes,
  currentDateTimeUTC
} from "@/utils/helper";
export default {
  components: {
    Skeleton
  },
  props: {
    searchData: {
      type: Function
    }
  },
  data() {
    return {
      isSending: false,

      formParam: {
        id: "",
        email: "",
        first_name: "",
        last_name: ""
      },
      isLoading: false
    };
  },
  watch: {
    isShowForm: {
      handler: function(val, oldVal) {
        // console.log("val", val, "oldVal", oldVal);
        if (val == true) {
          // this.selectedLicense = [];
          var that = this;
          setTimeout(function() {
            // console.log("that.broadcastParamSt", that.broadcastParamSt);
            if (that.formParamSt.id != "" && that.formParamSt.id != null) {
              that.formParam = that.formParamSt;
            } else {
              that.formParam = {
                id: "",
                email: "",
                first_name: "",
                last_name: ""
              };
            }
          }, 100);
        }
      },
      deep: true
    }
  },
  computed: {
    formParamSt() {
      return this.$store.state.agent.formParamSt;
    },
    isShowForm() {
      return this.$store.state.agent.isShowForm;
    }
  },
  methods: {
    async saveForm(isExit = 0) {
      this.$fire({
        title: "Are you sure you will continue this action?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `Yes`,
        denyButtonText: `Cancel`
      }).then(async r => {
        // console.log("rrrr", r);
        // return;
        if (r.value == true) {
          // console.log("valueee", r);
          this.isSending = await true;
          let action = "createStored";
          if (this.formParam.id != "") {
            action = "updateStored";
          }
          await this.$store
            .dispatch("agent/" + action, this.formParam)
            .then(response => {
              // this.isSending = false;
              if (this.formParam.id == "") {
                this.formParam = {
                  id: "",
                  email: "",
                  first_name: "",
                  last_name: ""
                };
              }

              this.$fire({
                title: "Success",
                text: response["msg"],
                type: "success",
                timer: 2000
              }).then(r => {});
              this.searchData();
              if (isExit == 1) {
                var elem = this.$refs.dismisModal;
                elem.click();
                this.formParam = {
                  id: "",
                  email: "",
                  first_name: "",
                  last_name: ""
                };
              }
              this.isSending = false;
            })
            .catch(() => {
              this.isSending = false;
            });
        }
      });
    }
  },
  async created() {},
  beforeDestroy() {},
  mounted() {
    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function(e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "add-edit-form"
};
</script>



// WEBPACK FOOTER //
// src/views/monitoring/agents/form.vue